import { render, staticRenderFns } from "./PanelSwitcherView.vue?vue&type=template&id=52865c31"
import script from "./PanelSwitcherView.vue?vue&type=script&lang=js"
export * from "./PanelSwitcherView.vue?vue&type=script&lang=js"
import style0 from "./PanelSwitcherView.vue?vue&type=style&index=0&id=52865c31&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports